import {Abstract} from "./Abstract";
import {IRouteDefinitionParams, IRuleset} from "../../../index";
import {ObjectTypeId} from "../../../constants";
import {nsRuleset} from "../nsRuleset";
import infoHtml from './info.html?raw';

export let template = infoHtml;

export class viewModel extends Abstract {

    private nsRuleset = nsRuleset

    constructor(params: IRouteDefinitionParams) {
        super(params);
    }

    private showElement(key: keyof IRuleset): boolean {
        switch (key) {
            case 'departmentexpression':
            case 'evaluatepositions':
                return this.data.objecttype.id == ObjectTypeId.User
            default:
                return true
        }
    }
}
